module.exports = "pegasus/assets/circle-google.png";